// extracted by mini-css-extract-plugin
module.exports = {"img":"Card_img__qr-qd","type":"Card_type__11f4e","name":"Card_name__1qjZb","card":"Card_card__1eE8R"};